/**
 * This patch prevents React from crashing when Google/Edge Translate mutates the DOM.
 * It intercepts Node removal and insertion errors, forcing a graceful fail instead of a fatal crash.
 */
export function applyTranslationPatch() {
    if (typeof Node === 'function' && Node.prototype) {
        const originalRemoveChild = Node.prototype.removeChild;
        Node.prototype.removeChild = function <T extends Node>(child: T): T {
            if (child.parentNode !== this) {
                // Only log warnings in development mode
                if (import.meta.env.DEV && typeof console !== 'undefined') {
                    console.warn(
                        'Translation Patch: Prevented crash on removeChild. Node not found in parent.',
                        { child, parent: this }
                    );
                }
                return child;
            }
            return originalRemoveChild.apply(this, [child]) as T;
        };

        const originalInsertBefore = Node.prototype.insertBefore;
        Node.prototype.insertBefore = function <T extends Node>(
            newNode: T,
            referenceNode: Node | null
        ): T {
            if (referenceNode && referenceNode.parentNode !== this) {
                // Only log warnings in development mode
                if (import.meta.env.DEV && typeof console !== 'undefined') {
                    console.warn(
                        'Translation Patch: Prevented crash on insertBefore. Reference node not found in parent.',
                        { newNode, referenceNode, parent: this }
                    );
                }
                return newNode;
            }
            return originalInsertBefore.apply(this, [newNode, referenceNode]) as T;
        };
    }
}